import React from 'react';
import { classIf } from '../../data/utils';
import ButtonsContainer from './ButtonsContainer';

function AggsContainer(props) {
    const aggregateBtns = props.aggs.map((ag, i) => {
        function handleClick() {
            props.onClick(ag.idAggregata);
        }

        return (
            <div key={ag.idAggregata} data-id={`a-${ag.idAggregata}`} className={"bg-bianco nero bordo-tondo elemento-macro pointer filter Zprincipali elementoDropdown" + classIf(ag.idAggregata === props.current, 'icona-selezionata')} onClick={handleClick}>
                <p>{ag.descrizione}</p>
            </div>
        )
    });

    return (
        <ButtonsContainer id={props.current} buttons={aggregateBtns} aggregate={true} />
    );
}

export default AggsContainer;
